import {useQuery} from "@tanstack/react-query";
import {qk} from "@queries/keys";
import ContactService from "@lib/Contact/ContactService";
import {Issue} from "@lib/Contact/ContactModels";

const hasPrivateFe = (issue: Issue) =>
    (issue.issueChannel ?? []).includes("PRIVATE_FE");

const hasInvoiceChannel = (issue: Issue) =>
    (issue.issueChannel ?? []).includes("PDA_KO");

export function useContactIssues() {
    return useQuery({
        queryKey: qk.contactIssues(),
        queryFn: () => ContactService.getIssueList(),
        staleTime: 10 * 60_000,
        retry: 1,
        select: (issues: Issue[]) => {
            return (issues ?? [])
                .filter(hasPrivateFe)
                .map((p) => ({
                    ...p,
                    children: (p.children ?? []).filter(hasPrivateFe),
                }))
                .filter((p) => (p.children?.length ?? 0) > 0);
        },
    });
}

export function useInvoiceIssues() {
    return useQuery({
        queryKey: qk.invoiceIssues(),
        queryFn: () => ContactService.getIssueList(),
        staleTime: 10 * 60_000,
        retry: 1,
        select: (issues: Issue[]) => {
            return (issues ?? [])
                .filter(hasInvoiceChannel)
        },
    });
}
